import { css } from 'styled-components';
import tokens from './tokens';

export type TypeStep = keyof typeof tokens.font.scale;
export type TypeWeight = keyof typeof tokens.font.weight;

/**
 * Applies one CVI type step (`tokens.font.scale`, see `tokens.ts` for the
 * scale itself and its provenance). `weight` overrides the step's own
 * default weight, e.g. `typeStep('sm', 'bold')` for bold body/sm text
 * instead of introducing a one-off `font-weight` literal at the call site.
 *
 * Some steps (currently only `xs`) also carry `letterSpacing` /
 * `textTransform`; those are narrowed with `'letterSpacing' in s` rather
 * than a cast because the `as const` tokens make those keys absent — not
 * merely undefined — on the steps that don't define them.
 */
export const typeStep = (step: TypeStep, weight?: TypeWeight) => css`
  font-size: ${p => p.theme.font.scale[step].size};
  line-height: ${p => p.theme.font.scale[step].lineHeight};
  font-weight: ${p =>
    weight ? p.theme.font.weight[weight] : p.theme.font.scale[step].weight};
  ${p => {
    const s = p.theme.font.scale[step];
    return css`
      ${'letterSpacing' in s ? css`letter-spacing: ${s.letterSpacing};` : ''}
      ${'textTransform' in s ? css`text-transform: ${s.textTransform};` : ''}
    `;
  }}
`;

export default typeStep;
